import { RelationshipLead } from '@/api/profiles.model';
import { ENVIRONMENT } from '@/lib/constants';

const RELATIONSHIP_LEAD_OPTIONS_API: RelationshipLead[] =
  ENVIRONMENT === 'production'
    ? [
        {
          firstName: 'Bryan',
          lastName: 'Kelly',
          primaryEmailAddress: 'bkelly@anthoscapital.com',
          id: 104505466,
        },
        {
          firstName: 'Emily',
          lastName: 'White',
          primaryEmailAddress: 'ewhite@anthoscapital.com',
          id: 104505471,
        },
        {
          firstName: 'Paul',
          lastName: 'Farr',
          primaryEmailAddress: 'pfarr@anthoscapital.com',
          id: 104505458,
        },
        {
          firstName: 'Roy',
          lastName: 'Stigall',
          primaryEmailAddress: 'rstigall@anthoscapital.com',
          id: 104505479,
        },
        {
          firstName: 'Zenetta',
          lastName: 'Burger',
          primaryEmailAddress: 'zburger@anthoscapital.com',
          id: 104505482,
        },
        {
          firstName: 'Bryan',
          lastName: 'Hale',
          primaryEmailAddress: 'bhale@anthoscapital.com',
          id: 147990980,
        },
        {
          firstName: 'Sam',
          lastName: 'Teden',
          primaryEmailAddress: 'steden@anthoscapital.com',
          id: 104505450,
        },
        {
          firstName: 'Zack',
          lastName: 'Zaharis',
          primaryEmailAddress: 'zzaharis@anthoscapital.com',
          id: 115476666,
        },
        {
          firstName: 'Jeffrey',
          lastName: 'Stapleton',
          primaryEmailAddress: 'jstapleton@anthoscapital.com',
          id: 104505473,
        },
        {
          firstName: 'Sasidhar',
          lastName: 'Vankina',
          primaryEmailAddress: 'svankina@anthoscapital.com',
          id: 104505475,
        },
        {
          firstName: 'Grace',
          lastName: 'Quackenbush',
          primaryEmailAddress: 'gquackenbush@anthoscapital.com',
          id: 104505728,
        },
        {
          firstName: 'Fara',
          lastName: 'Bakare',
          primaryEmailAddress: 'fbakare@anthoscapital.com',
          id: 167239020,
        },
        {
          firstName: 'Mike',
          lastName: 'Schember',
          primaryEmailAddress: 'mschember@anthoscapital.com',
          id: 104505661,
        },
        {
          firstName: 'Daniel',
          lastName: 'Flanagan',
          primaryEmailAddress: 'dflanagan@anthoscapital.com',
          id: 166888287,
        },
        {
          firstName: 'David',
          lastName: 'Collins',
          primaryEmailAddress: 'dcollins@anthoscapital.com',
          id: 105409203,
        },
        {
          firstName: 'Sue',
          lastName: 'Choe',
          primaryEmailAddress: 'schoe@anthoscapital.com',
          id: 104505452,
        },
        {
          firstName: 'Daniel',
          lastName: 'Knight',
          primaryEmailAddress: 'dknight@anthoscapital.com',
          id: 131183311,
        },
        {
          firstName: 'Bayley',
          lastName: 'Schmidt',
          primaryEmailAddress: 'bschmidt@anthoscapital.com',
          id: 104505456,
        },
        {
          firstName: 'Stacey',
          lastName: 'Stanley',
          primaryEmailAddress: 'sstanley@anthoscapital.com',
          id: 117123692,
        },
        {
          firstName: 'Hannah',
          lastName: 'Cornejo',
          primaryEmailAddress: 'hcornejo@anthoscapital.com',
          id: 205890269,
        },
        {
          firstName: 'Mikaila',
          lastName: 'For',
          primaryEmailAddress: 'mfor@anthoscapital.com',
          id: 104505454,
        },
        {
          firstName: 'Randall',
          lastName: 'Chandler',
          primaryEmailAddress: 'rchandler@anthoscapital.com',
          id: 104505447,
        },
        {
          firstName: 'Frances',
          lastName: 'Au-Yang',
          primaryEmailAddress: 'fauyang@anthoscapital.com',
          id: 104505481,
        },
        {
          firstName: 'Jason',
          lastName: 'Soto',
          primaryEmailAddress: 'jsoto@anthoscapital.com',
          id: 173990233,
        },
        {
          firstName: 'Kelly',
          lastName: 'Kong',
          primaryEmailAddress: 'kkong@anthoscapital.com',
          id: 165165716,
        },
        {
          firstName: 'Maggie',
          lastName: 'Luchsinger',
          primaryEmailAddress: 'mluchsinger@anthoscapital.com',
          id: 104505480,
        },
        {
          firstName: 'Stephen',
          lastName: 'Harris',
          primaryEmailAddress: 'sharris@anthoscapital.com',
          id: 104505465,
        },
        {
          firstName: 'Akash',
          lastName: 'Shah',
          primaryEmailAddress: 'ashah@anthoscapital.com',
          id: 111499656,
        },
        {
          firstName: 'Jacob',
          lastName: 'Hochadel',
          primaryEmailAddress: 'jhochadel@anthoscapital.com',
          id: 105407889,
        },
        {
          firstName: 'Andrew',
          lastName: 'Cafourek',
          primaryEmailAddress: 'acafourek@anthoscapital.com',
          id: 104445387,
        },
        {
          firstName: 'Scott',
          lastName: 'Norton',
          primaryEmailAddress: 'snorton@anthoscapital.com',
          id: 104670260,
        },
        {
          firstName: 'Jimmy',
          lastName: 'DeCicco',
          primaryEmailAddress: 'jdecicco@anthoscapital.com',
          id: 199230309,
        },
        {
          id: 192124415,
          lastName: 'Molina',
          firstName: 'Christy',
          primaryEmailAddress: 'cmolina@anthoscapital.com',
        },
      ].sort((a, b) => a.firstName.localeCompare(b.firstName))
    : [
        {
          firstName: 'Bryan',
          lastName: 'Kelly',
          primaryEmailAddress: 'bkelly@anthoscapital.com',
          id: 133153067,
        },
        {
          firstName: 'Emily',
          lastName: 'White',
          primaryEmailAddress: 'ewhite@anthoscapital.com',
          id: 133147549,
        },
        {
          firstName: 'Paul',
          lastName: 'Farr',
          primaryEmailAddress: 'pfarr@anthoscapital.com',
          id: 166813249,
        },
        {
          firstName: 'Roy',
          lastName: 'Stigall',
          primaryEmailAddress: 'rstigall@anthoscapital.com',
          id: 133153071,
        },
        {
          firstName: 'Zenetta',
          lastName: 'Burger',
          primaryEmailAddress: 'zburger@anthoscapital.com',
          id: 133153057,
        },
        {
          firstName: 'Bryan',
          lastName: 'Hale',
          primaryEmailAddress: 'bhale@anthoscapital.com',
          id: 166813246,
        },
        {
          firstName: 'Sam',
          lastName: 'Teden',
          primaryEmailAddress: 'steden@anthoscapital.com',
          id: 133153061,
        },
        {
          firstName: 'Zack',
          lastName: 'Zaharis',
          primaryEmailAddress: 'zzaharis@anthoscapital.com',
          id: 166813263,
        },
        {
          firstName: 'Jeffrey',
          lastName: 'Stapleton',
          primaryEmailAddress: 'jstapleton@anthoscapital.com',
          id: 133147551,
        },
        {
          firstName: 'Sasidhar',
          lastName: 'Vankina',
          primaryEmailAddress: 'svankina@anthoscapital.com',
          id: 166813256,
        },
        {
          firstName: 'Grace',
          lastName: 'Quackenbush',
          primaryEmailAddress: 'gquackenbush@anthoscapital.com',
          id: 166813537,
        },
        {
          firstName: 'Fara',
          lastName: 'Bakare',
          primaryEmailAddress: 'fbakare@anthoscapital.com',
          id: 210925390,
        },
        {
          firstName: 'Mike',
          lastName: 'Schember',
          primaryEmailAddress: 'mschember@anthoscapital.com',
          id: 166813258,
        },
        {
          firstName: 'Daniel',
          lastName: 'Flanagan',
          primaryEmailAddress: 'dflanagan@anthoscapital.com',
          id: 210925377,
        },
        {
          firstName: 'David',
          lastName: 'Collins',
          primaryEmailAddress: 'dcollins@anthoscapital.com',
          id: 166813595,
        },
        {
          firstName: 'Sue',
          lastName: 'Choe',
          primaryEmailAddress: 'schoe@anthoscapital.com',
          id: 166813243,
        },
        {
          firstName: 'Daniel',
          lastName: 'Knight',
          primaryEmailAddress: 'dknight@anthoscapital.com',
          id: 166813242,
        },
        {
          firstName: 'Bayley',
          lastName: 'Schmidt',
          primaryEmailAddress: 'bschmidt@anthoscapital.com',
          id: 166813272,
        },
        {
          firstName: 'Stacey',
          lastName: 'Stanley',
          primaryEmailAddress: 'sstanley@anthoscapital.com',
          id: 210925356,
        },
        {
          firstName: 'Hannah',
          lastName: 'Cornejo',
          primaryEmailAddress: 'hcornejo@anthoscapital.com',
          id: 210925339,
        },
        {
          firstName: 'Mikaila',
          lastName: 'For',
          primaryEmailAddress: 'mfor@anthoscapital.com',
          id: 166813248,
        },
        {
          firstName: 'Randall',
          lastName: 'Chandler',
          primaryEmailAddress: 'rchandler@anthoscapital.com',
          id: 133147550,
        },
        {
          firstName: 'Frances',
          lastName: 'Au-Yang',
          primaryEmailAddress: 'fauyang@anthoscapital.com',
          id: 210925321,
        },
        {
          firstName: 'Jason',
          lastName: 'Soto',
          primaryEmailAddress: 'jsoto@anthoscapital.com',
          id: 210925306,
        },
        {
          firstName: 'Kelly',
          lastName: 'Kong',
          primaryEmailAddress: 'kkong@anthoscapital.com',
          id: 210925277,
        },
        {
          firstName: 'Maggie',
          lastName: 'Luchsinger',
          primaryEmailAddress: 'mluchsinger@anthoscapital.com',
          id: 166813301,
        },
        {
          firstName: 'Stephen',
          lastName: 'Harris',
          primaryEmailAddress: 'sharris@anthoscapital.com',
          id: 166813528,
        },
        {
          firstName: 'Akash',
          lastName: 'Shah',
          primaryEmailAddress: 'ashah@anthoscapital.com',
          id: 166813525,
        },
        {
          firstName: 'Jacob',
          lastName: 'Hochadel',
          primaryEmailAddress: 'jhochadel@anthoscapital.com',
          id: 166813270,
        },
        {
          firstName: 'Andrew',
          lastName: 'Cafourek',
          primaryEmailAddress: 'acafourek@anthoscapital.com',
          id: 133153079,
        },
        {
          firstName: 'Scott',
          lastName: 'Norton',
          primaryEmailAddress: 'snorton@anthoscapital.com',
          id: 210975982,
        },
        {
          firstName: 'Jimmy',
          lastName: 'DeCicco',
          primaryEmailAddress: 'jdecicco@anthoscapital.com',
          id: 210976006,
        },
        {
          firstName: 'Mauro',
          lastName: 'Cappelloni',
          primaryEmailAddress: 'mauro.cappelloni@loop3studio.com',
          id: 166813354,
        },
        {
          firstName: 'Sebas',
          lastName: 'Belaustegui',
          primaryEmailAddress: 'sebastian.belaustegui@loop3studio.com',
          id: 178680192,
        },
        {
          firstName: 'Tomas',
          lastName: 'Causa',
          primaryEmailAddress: 'tom.causa@loop3studio.com',
          id: 166813352,
        },
        {
          id: 192135364,
          lastName: 'Molina',
          firstName: 'Christy',
          primaryEmailAddress: 'cmolina@anthoscapital.com',
        },
      ].sort((a, b) => a.firstName.localeCompare(b.firstName));

export { RELATIONSHIP_LEAD_OPTIONS_API };
